import ajaxService from './ajaxService';

export default {
  getChannel(params, headers) {
    const queryString = new URLSearchParams(params).toString();
    return ajaxService.post(`/com/get/api/v1/channel?${queryString}`, {}, headers);
  },
};
